import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./banner_slideshow.css";

const BannerSlider = () => {
  const bannerImages = [
    "/images/header-img-1.jpg",
    "/images/header-img-2.jpg",
    "/images/header-img-3.jpg"
  ];

  return (
    <section className="banner-swiper">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        slidesPerView={1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false
        }}
        loop={true}  // Enable cyclic/loop mode
      >
        {bannerImages.map((src, idx) => (
          <SwiperSlide key={idx}>
            <div className="banner-slide">
              {/* Main banner image */}
              <img 
                src={src} 
                alt={`Banner slide ${idx}`} 
                className="banner-image" 
              />

              {/* Small .png overlay on top-left */}
              {/* <img
                src="/images/star-free-vector.png"  // <--- path to your .png
                alt="Icon Overlay"
                className="banner-overlay"
              /> */}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default BannerSlider;